import type { Contact } from '@ui/shared/ui-detail-view';
import { type CultureMapItem, CultureMapItemModel } from './culture-map-item.model';
import type { ExperienceType } from './experience-type.model';
import type { TargetGroup } from './target-group.model';

export interface AccessibilityFeature {
    id: number;
    locationAccess?: boolean;
    elevatorAccess?: string;
    toiletAccess?: boolean;
    toiletNursingBed?: boolean;
    inductionLoop?: boolean;
    audioDescription?: boolean;
    audioGuide?: boolean;
    blindGuidanceSystem?: boolean;
    otherOrientationAids?: boolean;
    interpreterAccess?: string;
    informationMaterialSimpleLanguage?: boolean;
    websiteSimpleLanguage?: boolean;
    inclusionContact: Contact;
}

export type CultureMapOfferingItem = CultureMapItem & {
    cultureSectorDescription: string;
    targetGroups: Array<TargetGroup>;
    cultureExperienceTypes: Array<ExperienceType>;
    cultureUsageType?: string;
    languages?: string;
    contact: Contact;
    accessibilityFeatures: AccessibilityFeature;
    openingHours?: string;
    offerPeriod?: string;
    cultureCategories: Array<string>;
};

export class CultureMapOfferingItemModel extends CultureMapItemModel {

    public cultureSectorDescription: string;
    public targetGroups: Array<TargetGroup>;
    public cultureExperienceTypes: Array<ExperienceType>;
    public cultureUsageType?: string;
    public languages?: string;
    public contact: Contact;
    public accessibilityFeatures: AccessibilityFeature;
    public openingHours?: string;
    public offerPeriod?: string;
    public cultureCategories: Array<string>;

    constructor(mapItem: CultureMapOfferingItem) {
        super(mapItem);

        this.cultureSectorDescription = mapItem.cultureSectorDescription;
        this.targetGroups = mapItem.targetGroups;
        this.cultureExperienceTypes = mapItem.cultureExperienceTypes;
        this.cultureUsageType = mapItem.cultureUsageType;
        this.languages = mapItem.languages;
        this.contact = mapItem.contact;
        this.accessibilityFeatures = mapItem.accessibilityFeatures;
        this.openingHours = mapItem.openingHours;
        this.offerPeriod = mapItem.offerPeriod;
        this.cultureCategories = mapItem.cultureCategories;
    }
}
